import { createFileRoute } from "@tanstack/react-router"
import Status from "~/pages/status"

export const Route = createFileRoute("/_auth/internal/status/")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <Status />
}
